<div [class]="model.cssClasses.rootDropdown">
  <sv-ng-dropdown [model]="model"></sv-ng-dropdown>
</div> 